export default "__VITE_ASSET__d8b63a9e__"